import { getTransactionId } from '../../common/data';
import { axios } from '../index';

const { REACT_APP_API_GATEWAY, REACT_APP_BACKEND_BRAND } = process.env;

export const sendIdentProcessEmail = async (): Promise<any> => {
  const dataStorageId = getTransactionId();
  const url = `${REACT_APP_API_GATEWAY}/ident/${REACT_APP_BACKEND_BRAND}/${dataStorageId}/email`;

  return axios
    .post(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
